
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../Global/axios";
import nodeinstance from "../../nodeInstance";

const getemployeemobilizationData = createAsyncThunk("api/mobilization", async (token) => {
  try {
    const response = await nodeinstance.get("/mobilization", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data;
  } catch (e) {
    throw new Error(e.message);
  }
});

const mobilizationDataSlice = createSlice({
  name: "mobilization",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {}, // You can define your other regular reducers here if needed.
  extraReducers: (builder) => {
    builder
      .addCase(getemployeemobilizationData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
        state.status = true
      })
      .addCase(getemployeemobilizationData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getemployeemobilizationData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getemployeemobilizationData };
export default mobilizationDataSlice.reducer;
